import React from 'react';
import { BarChart3, PieChart, Download, Calendar, ArrowUpRight, ArrowDownRight } from 'lucide-react';
export function ReportsPage() {
  const monthlyData = [{
    month: 'May',
    amount: 45000,
    height: 'h-32'
  }, {
    month: 'Jun',
    amount: 52000,
    height: 'h-40'
  }, {
    month: 'Jul',
    amount: 48000,
    height: 'h-36'
  }, {
    month: 'Aug',
    amount: 61000,
    height: 'h-48'
  }, {
    month: 'Sep',
    amount: 55000,
    height: 'h-44'
  }, {
    month: 'Oct',
    amount: 68000,
    height: 'h-56'
  }];
  return <div className="space-y-6" data-id="element-1236">
      <div className="flex items-center justify-between" data-id="element-1237">
        <div data-id="element-1238">
          <h2 className="text-2xl font-bold text-slate-800" data-id="element-1239">
            Reports & Analytics
          </h2>
          <p className="text-slate-500" data-id="element-1240">
            Deep dive into travel patterns and expenses.
          </p>
        </div>
        <div className="flex gap-3" data-id="element-1241">
          <button className="flex items-center rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50" data-id="element-1242">
            <Calendar className="mr-2 h-4 w-4" data-id="element-1243" />
            Last 30 Days
          </button>
          <button className="flex items-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700" data-id="element-1244">
            <Download className="mr-2 h-4 w-4" data-id="element-1245" />
            Export Data
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-1246">
        {/* Spend by Category - Donut Chart */}
        <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-1247">
          <h3 className="mb-6 font-semibold text-slate-800" data-id="element-1248">
            Spend by Category
          </h3>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-8" data-id="element-1249">
            <div className="relative h-48 w-48 rounded-full" style={{
            background: 'conic-gradient(#3b82f6 0% 45%, #10b981 45% 75%, #f59e0b 75% 90%, #64748b 90% 100%)'
          }} data-id="element-1250">
              <div className="absolute inset-0 m-auto h-32 w-32 rounded-full bg-white flex items-center justify-center flex-col" data-id="element-1251">
                <span className="text-2xl font-bold text-slate-800" data-id="element-1252">$329k</span>
                <span className="text-xs text-slate-500" data-id="element-1253">Total YTD</span>
              </div>
            </div>

            <div className="space-y-3 w-full sm:w-auto" data-id="element-1254">
              <div className="flex items-center justify-between sm:justify-start gap-3" data-id="element-1255">
                <div className="h-3 w-3 rounded-full bg-blue-500" data-id="element-1256"></div>
                <span className="text-sm text-slate-600 w-24" data-id="element-1257">Flights</span>
                <span className="text-sm font-semibold text-slate-900" data-id="element-1258">
                  45%
                </span>
              </div>
              <div className="flex items-center justify-between sm:justify-start gap-3" data-id="element-1259">
                <div className="h-3 w-3 rounded-full bg-emerald-500" data-id="element-1260"></div>
                <span className="text-sm text-slate-600 w-24" data-id="element-1261">Hotels</span>
                <span className="text-sm font-semibold text-slate-900" data-id="element-1262">
                  30%
                </span>
              </div>
              <div className="flex items-center justify-between sm:justify-start gap-3" data-id="element-1263">
                <div className="h-3 w-3 rounded-full bg-amber-500" data-id="element-1264"></div>
                <span className="text-sm text-slate-600 w-24" data-id="element-1265">Transport</span>
                <span className="text-sm font-semibold text-slate-900" data-id="element-1266">
                  15%
                </span>
              </div>
              <div className="flex items-center justify-between sm:justify-start gap-3" data-id="element-1267">
                <div className="h-3 w-3 rounded-full bg-slate-500" data-id="element-1268"></div>
                <span className="text-sm text-slate-600 w-24" data-id="element-1269">Other</span>
                <span className="text-sm font-semibold text-slate-900" data-id="element-1270">
                  10%
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Monthly Spend Trend - Bar Chart */}
        <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-1271">
          <div className="flex items-center justify-between mb-6" data-id="element-1272">
            <h3 className="font-semibold text-slate-800" data-id="element-1273">
              Monthly Spend Trend
            </h3>
            <div className="flex items-center text-sm text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full" data-id="element-1274">
              <ArrowUpRight className="h-4 w-4 mr-1" data-id="element-1275" />
              <span data-id="element-1276">+12.5% vs last year</span>
            </div>
          </div>

          <div className="flex h-48 items-end justify-between gap-2 pt-4" data-id="element-1277">
            {monthlyData.map(item => <div key={item.month} className="flex flex-col items-center gap-2 w-full group" data-id="element-1278">
                <div className="relative w-full flex justify-center" data-id="element-1279">
                  <span className="absolute -top-8 text-xs font-medium text-slate-900 opacity-0 group-hover:opacity-100 transition-opacity bg-white shadow-sm border border-slate-200 px-2 py-1 rounded" data-id="element-1280">
                    ${(item.amount / 1000).toFixed(1)}k
                  </span>
                  <div className={`w-full max-w-[40px] rounded-t-md bg-blue-500 hover:bg-blue-600 transition-colors ${item.height}`} data-id="element-1281"></div>
                </div>
                <span className="text-xs font-medium text-slate-500" data-id="element-1282">
                  {item.month}
                </span>
              </div>)}
          </div>
        </div>
      </div>

      {/* Detailed Table */}
      <div className="rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-1283">
        <div className="border-b border-slate-200 px-6 py-4" data-id="element-1284">
          <h3 className="font-semibold text-slate-800" data-id="element-1285">Expense Details</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-1286">
          <table className="w-full text-left text-sm" data-id="element-1287">
            <thead className="bg-slate-50 text-slate-500" data-id="element-1288">
              <tr data-id="element-1289">
                <th className="px-6 py-3 font-medium" data-id="element-1290">Category</th>
                <th className="px-6 py-3 font-medium" data-id="element-1291">Vendor</th>
                <th className="px-6 py-3 font-medium" data-id="element-1292">Transactions</th>
                <th className="px-6 py-3 font-medium" data-id="element-1293">Total Spend</th>
                <th className="px-6 py-3 font-medium" data-id="element-1294">Avg. Ticket</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1295">
              {[{
              cat: 'Air Travel',
              vendor: 'United Airlines',
              count: 145,
              total: '$68,450',
              avg: '$472'
            }, {
              cat: 'Air Travel',
              vendor: 'Delta',
              count: 98,
              total: '$42,100',
              avg: '$429'
            }, {
              cat: 'Hotel',
              vendor: 'Marriott',
              count: 210,
              total: '$52,500',
              avg: '$250'
            }, {
              cat: 'Hotel',
              vendor: 'Hilton',
              count: 185,
              total: '$44,400',
              avg: '$240'
            }, {
              cat: 'Ground',
              vendor: 'Uber',
              count: 450,
              total: '$12,200',
              avg: '$27'
            }].map((row, i) => <tr key={i} className="hover:bg-slate-50" data-id="element-1296">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-1297">
                    {row.cat}
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-1298">{row.vendor}</td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-1299">{row.count}</td>
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-1300">
                    {row.total}
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-1301">{row.avg}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}